@if (showBanner) {
<div class="cookie-consent">
  <div class="container-fluid">
    <div class="banner">
      <div class="contentImage">
        <img
          src="/generals/icon-close.svg"
          alt="Cerrar"
          width="24"
          height="24"
          fill
          aria-hidden="true"
          (click)="acceptCookies()"
        />
      </div>
      <p class="title">SITSA utiliza cookies</p>
      <p>
        Al navegar en nuestro sitio permites el uso de <b>“cookies”</b> en tu dispositivo, con las
        que podemos ofrecerte una mejor experiencia de navegación, así como analizar el uso del
        sitio.
        <b>No utilizamos ningún tipo de información personal.</b>
      </p>
      <div class="flex">
        <a routerLink="/politica-de-cookies">Consultar Política de Cookies</a>
        <button (click)="acceptCookies()" class="btnSitsa">Aceptar cookies</button>
      </div>
    </div>
  </div>
</div>
}
